import React from "react";
import { Container } from "react-bootstrap";

import Seo from "components/Seo";
import CenterSpinner from "components/CenterSpinner";
import { useMetadata, usePresentationBySlug } from "hooks/query";
import { useSection } from "hooks/section";
import Header from "./Header";
import Tabs from "./Tabs";
import StudentjobbButtons from "./StudentjobbButtons";
import SearchAside from "components/SearchAside";
import NotFound from "routes/NotFound";
import { ScrollToTop } from "components/ScrollToTop";

export default function Presentaton() {
    const presentationQuery = usePresentationBySlug();
    const metadataQuery = useMetadata();
    let { sectionUrl } = useSection();
    if(!presentationQuery.isLoading &&  presentationQuery.isError){
        return <NotFound/>
    }
    else{
    return (
        <div className="Presentation">
            <div className="container-fluid">
                {presentationQuery.isLoading || metadataQuery.isLoading ? (
                    <CenterSpinner />
                ) : (
                    <>
                        <Seo
                            title={presentationQuery.data.name}
                            image={presentationQuery.data.img}
                            keywords={presentationQuery.data.keyword}
                            description={presentationQuery.data.shortDescription}
                        />       
                        
                        <ScrollToTop/>
                        <Container>
                        <Header sectionUrl={sectionUrl} />
                        </Container>
                        <Container fluid>                            
                            <SearchAside adCache={false}>
                                {sectionUrl == "traineeprogram" && <StudentjobbButtons />}
                                <Tabs />
                            </SearchAside>
                        </Container>
                    </>
                )}
            </div>
        </div>
    );}
}
